import { tradingType } from '@sparling/financial-common'

const types = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const item of tradingType) {
  types.push({
    value: item,
    label: item,
  })
}

export const CRM_TRADING_TYPE = types
